<template>
	<section class="content">
		<header>
			<h3><i class="fas fa-profile"></i>Personal</h3>
		</header>
		<spinner v-if="userStatus.loading"></spinner>
		<span class="list-group" v-else>
			<setting-expand
				:label="'Address'"
				class="address"
				:input-ref="'address'"
				:button-show-text="'Change Address'"
				:button-hide-text="'Cancel'">
				<div slot="displayValue">
					{{user.address.firstName}} {{user.address.lastName}}<br>
					{{user.address.organization}}<br>
					{{user.address.addressLine1}}<br>
					<span v-if="user.address.addressLine2">{{user.address.addressLine2}}<br></span>
					{{user.address.city.trim()}}<span v-if="user.address.state">, {{user.address.state.trim()}}</span> {{user.address.postalCode}}<br>
					{{user.address.country | country}}
				</div>
				<div class="notice">
					Need to change your address? Send us a <a class="rigid" href="mailto:support@support.tekcloud.com?subject=Change%20Address">note</a> and we'll update it for you.
				</div>
			</setting-expand>
		</span>
	</section>
</template>

<script>
import SettingInput from '../components/SettingInput';
import SettingExpand from '../components/SettingExpand';
import SettingLink from '../components/SettingLink';
import Collapsible from '../components/Collapsible';
import country from '../filters/country';
import VueImg from '../components/VueImg';
import Spinner from '../components/Spinner';
import { mapGetters } from 'vuex';
export default {
	name: 'Personal',
	data() {
		return {
			email: '',
			newEmail: '',
		};
	},
	computed: {
		...mapGetters([
			'user',
			'roles',
			'userStatus',
			'userStatusEmail',
			'accountStatus',
			'tfa'
		])
	},
	filters: {
		country
	},
	components: {
		SettingInput,
		SettingExpand,
		Spinner,
		Collapsible,
		VueImg,
		SettingLink
	},
	methods: {
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.list-item .notice {
	    padding: .8em;
	}
</style>



// WEBPACK FOOTER //
// ./src/views/Personal.vue